import { contentfulImageSchema } from '@ecomm/contentful-components'
import { guidedSystemBuilderSchema } from '@ecomm/shared-components/v2/lib/GuidedSystemBuilder/schema'
import { z } from '@simplisafe/ewok'
import type { TypeOf } from '@simplisafe/ewok'

const idSchema = z.object({
  id: z.string()
})

export const headerRedesignSchema = z.object({
  images: z.object({
    items: contentfulImageSchema
      .extend({ contentful_id: idSchema.transform(sysObj => sysObj.id) })
      .array()
  }),
  quoteWizard: guidedSystemBuilderSchema
})

export type HeaderRedesignSchema = TypeOf<typeof headerRedesignSchema>
